import { updatePostcodeAction } from '../../_flux/actions/postcode_actions';
import MapActions from '../../_flux/actions/map_actions';
import StationsActions from '../../_flux/actions/fitting_station_actions';
import MapStore from '../../_flux/stores/map_store';
import { ProductsStore } from '../../_flux/stores/products_store';

export function loadStations(postcode) {
    updatePostcodeAction(postcode, true);
    StationsActions.startFetchingStationsAction();

    return MapActions.updateLatLngAction(postcode).then(() => {
        const products = ProductsStore.getState();
        const product = products[0];
        const mapStoreState = MapStore.getState();

        return StationsActions.fetchStationsAction({
            postcode: postcode,
            latitude: mapStoreState.latLng.lat(),
            longitude: mapStoreState.latLng.lng(),
            qty: product.qty,
            id: product.id
        }, products);
    });
}
